(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["beador-event-gallery"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('beador-event-gallery')) {
  customElements.define('beador-event-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.onScroll) return;
      this.rail = this.querySelector('.bd-event__rail');
      this.frames = Array.from(this.querySelectorAll('.bd-event__frame'));
      if (!this.frames.length) return;
      this.querySelector('.bd-event__controls').hidden = false;
      this.buttons = Array.from(this.querySelectorAll('[data-step]'));
      this.update = () => {
        const start = this.frames[0].offsetLeft;
        this.index = this.frames.reduce((best, frame, i) => Math.abs(frame.offsetLeft - start - this.rail.scrollLeft) < Math.abs(this.frames[best].offsetLeft - start - this.rail.scrollLeft) ? i : best, 0);
        this.querySelector('.bd-event__count').textContent = String(this.index + 1).padStart(2, '0') + ' / ' + String(this.frames.length).padStart(2, '0');
        this.buttons[0].disabled = this.rail.scrollLeft < 2;
        this.buttons[1].disabled = this.rail.scrollLeft + this.rail.clientWidth >= this.rail.scrollWidth - 2;
      };
      this.onClick = (event) => {
        const button = event.target.closest('[data-step]');
        if (!button) return;
        const next = Math.max(0, Math.min(this.frames.length - 1, this.index + Number(button.dataset.step)));
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.rail.scrollTo({left: this.frames[next].offsetLeft - this.frames[0].offsetLeft, behavior: reduced ? 'auto' : 'smooth'});
      };
      this.onScroll = () => this.update();
      this.addEventListener('click', this.onClick);
      this.rail.addEventListener('scroll', this.onScroll, {passive:true});
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.rail);
      this.update();
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.rail?.removeEventListener('scroll', this.onScroll);
      this.observer?.disconnect();
      this.onScroll = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
